import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import ActionAdd from '../../store/action/TemplateSender/Add'
import ActionDelete from '../../store/action/TemplateSender/Delete'
import ActionGetClient from '../../store/action/Client/FetchAll'
import ActionGetSender from '../../store/action/Sender/FetchAll'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetNameSpace from '../../store/action/RegisterTemplate/FetchNamespace'
import ActionGetAllTemplate from '../../store/action/TemplateHsm/Fetch'
import Swal from 'sweetalert2'

class Form extends Component{

  constructor(props){
      super(props);
      this.state ={
          form : fromJS({
              "client-id": "",
              "sender-id": "",
              // "namespace":""
          }),
          loadded: false,
          disabled: false,
          disabledDeleted:true,
          errors: fromJS({}),
          error: '',
          // ctNamespace:0,
          // namespaceArr:[],
          // idNamespaces:[]
          ctTemplate:0,
          templateArr:[],
          idTemplate:[]
      };
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleCancel = this.handleCancel.bind(this);
      this.handleRemove = this.handleRemove.bind(this);
      this.showNamespaceDynamic = this.showNamespaceDynamic.bind(this);
  }

  handleChange(field, value) {
      var formVal = this.state.form;
      formVal = formVal.set(field,value);
      if(field === 'client-id'){
          this.props.actionGetSender(value)
          this.props.actionGetNameSpace(value);
          this.props.actionGetAllTemplate(value)
      }
      this.setState({ form:formVal })
  }

  async handleRemove(e){
      var idTemplateDelete = e.target.value
      var data = {
          'data' :
              {
                  "id": idTemplateDelete
              }
      };

      var response = await this.props.actionDelete(data);
      if(response.ok){
          toast.success('Delete Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(true);
      }else{
          toast.error('Delete Failed', toast.POSITION.TOP_RIGHT);
      }

  }

  async handleSubmit(dispatch) {
      const form = this.state.form;

      if(form.get('client-id') === null || form.get('client-id') === "") {
          toast.error('Client Id is Required, can not be empty!', toast.POSITION.TOP_RIGHT);
          return false
      }

      if(form.get('sender-id') === null || form.get('sender-id') === "") {
          toast.error('Waba Number Id is Required, can not be empty!', toast.POSITION.TOP_RIGHT);
          return false
      }

      switch(this.props.actionType) {
          case IsCreate:
              await this.SubmitNewData();
              break;
          case IsEdit:
              Swal.fire({
                  title: 'Do you want to save the changes?',
                  icon: 'question',
                  showDenyButton: true,
                  showCancelButton: true,
                  confirmButtonText: `Save`,
                  denyButtonText: `Don't save`,
              }).then((result) => {
                  if (result.isConfirmed) {
                      this.SubmitEditData();
                  } else if (result.isDenied) {
                      Swal.fire('Changes are not saved', '', 'info')
                      this.props.handleCancelForm(true);
                  }
              })

              break;
          default:
      }
  }

  async SubmitNewData(){
      const form = this.state.form;
      var ctTemplate = this.state.ctTemplate;
      var arrTemplate = [];
      if(ctTemplate>0){
          for(var k=1; k<=ctTemplate; k++){
              if(!arrTemplate.includes(form.get("template_"+k)) && form.get("template_"+k)!=null){
                  arrTemplate.push(form.get("template_"+k));
              }
          }
      }
      if(arrTemplate.length===0) {
          toast.error('Template is Required, can not be empty!', toast.POSITION.TOP_RIGHT);
          return false
      }
      var data = {
          'data' :
              {
                  "sender-id": form.get("sender-id"),
                  "template-id":arrTemplate,
              }
      };

      var response = await this.props.actionAdd(data);
      if(response.ok){
          toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
          this.props.handleCancelForm(false);
      }else{
          toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
      }
  }

  async SubmitEditData(){
      const form = this.state.form;
      var ctTemplate = this.state.ctTemplate;
      var arrTemplate = [];
      if(ctTemplate>0){
          for(var k=1; k<=ctTemplate; k++){
              if(!arrTemplate.includes(form.get("template_"+k)) && form.get("template_"+k)!=null){
                  arrTemplate.push(form.get("template_"+k));
              }
          }
      }
      if(arrTemplate.length===0) {
          toast.error('Template is Required, can not be empty!', toast.POSITION.TOP_RIGHT);
          return false
      }

      var data =
          {'data' :
              {
                  "client-id": form.get("client-id"),
                  "sender-id": form.get("sender-id"),
                  "template-id": arrTemplate
              }
          };
      //debugger;
      // var response = await this.props.actionEdit(data);
      // if(response.ok){
      //     toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
      //     this.props.handleCancelForm(true);
      // }else{
      //     toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
      // }
  }

  handleCancel(){
      this.props.handleCancelForm(false);
  }

  componentWillMount(){
      if(this.props.item != null || this.props.item !== undefined){

          if((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded){
              var opt = []
              var dataTemplate = this.props.item.get("templates")
              dataTemplate.map((item) => {
                  opt.push({id:item.get('id'), value: item.get('template-name'), idTemp:item.get('template-id')})
              })
              var ctTemplate = opt.length;
              var  darstrName = [];
              var  idTemplate = [];
              var formVal = this.state.form;

              for(var p=1; p<=ctTemplate; p++){
                  let strName = "template_"+p;
                  formVal = formVal.set(strName,opt[p-1]["idTemp"].toString());
                  darstrName.push(opt[p-1]["value"])
                  idTemplate.push(opt[p-1]["id"])
              }
              formVal = formVal.set("sender-id",this.props.item.get("sender-id"));
              formVal = formVal.set("client-id",this.props.item.get("client-id"));
              this.setState({
                  form:  formVal,
                  loadded: true,
                  disabled: (this.props.actionType === IsView),
                  disableStatus:false,
                  ctTemplate:ctTemplate,
                  templateArr:darstrName,
                  idTemplate:idTemplate,
                  disabledDeleted:(this.props.actionType !== IsView),
              })
              //debugger;
          }
      }
  }

  componentDidMount(){
      let formVal = this.state.form
      this.props.actionGetClient()

      if(this.props.actionType === IsView || this.props.actionType === IsEdit) {
          this.props.actionGetSender(formVal.get("client-id"));
          this.props.actionGetNameSpace(formVal.get("client-id"));
          this.props.actionGetAllTemplate(formVal.get("client-id"));
      }
  }

    showNamespaceDynamic(){
        var form = this.state.ctTemplate;
        var ctNew =form+1;
        this.setState({ctTemplate:ctNew});
    }

  render(){
      const {form, errors} = this.state;
      var ctTemp = this.state.ctTemplate;
      var arrId = this.state.idTemplate;
      // The added element component
      let AddedElement =[];
      if(ctTemp>0){
          for(let k=1; k<=ctTemp; k++){

              AddedElement.push(
              <div className="form-group row">
                  <span className="col-sm-2"></span>
                  <div className="col-sm-8">
                      <ComboboxInput
                          field={'template_'+k}
                          value={form.get('template_'+k)}
                          options={fromJS({
                              'source':this.props.templateall,
                              'value': 'template-id',
                              'label': 'template-name'
                          }) }
                          onChange={(field, value, label) => this.handleChange(field,value,label)}
                          placeholder={'Template ke '+k}
                          disabled={this.state.disabled}
                      />
                  </div>
                  <div className="col-sm-2">
                      <button
                          type="button"
                          className="btn btn-danger"
                          value={arrId[k-1]}
                          disabled={this.state.disabledDeleted}
                          onClick={this.handleRemove}>

                          Delete
                      </button>
                  </div>
              </div>
              );
          }
      }
      return (
          <div className="body">
              <div className="form-group row">
                  <span className="col-sm-2">Client</span>
                  <div className="col-sm-10">
                      <ComboboxInput
                          field='client-id'
                          value={form.get('client-id')}
                          options={fromJS({
                              'source': this.props.clientall,
                              'value': 'client-id',
                              'label': 'client-name'
                          })}
                          onChange={(field, value, label) => this.handleChange(field,value, label)}
                          placeholder="Client"
                          disabled={this.state.disabled}
                          hasError={errors.has('client-id')}
                      />
                  </div>
              </div>
              <div className="form-group row">
                  <span className="col-sm-2">Sender</span>
                  <div className="col-sm-10">
                      <ComboboxInput
                          field='sender-id'
                          value={form.get('sender-id')}
                          options={fromJS({
                              'source': this.props.senders,
                              'value': 'sender-id',
                              'label': 'sender-name'
                          })}
                          onChange={(field, value, label) => this.handleChange(field,value, label)}
                          placeholder="Sender"
                          disabled={this.state.disabled}
                          hasError={errors.has('sender-id')}
                      />
                  </div>
              </div>
              <div className="form-group row">
                  <span className="col-sm-2">Template</span>
                  <div className="col-sm-2">
                      <button
                          type="button"
                          className="btn btn-success"
                          disabled={this.state.disabled}
                          onClick={ this.showNamespaceDynamic}>
                          add Template
                      </button>
                  </div>
              </div>
              <div id={"namespaceAdding"}>
                  {AddedElement}
              </div>

              <div className="form-group row">
                  <span className="col-sm-2"></span>
                  <div className="col-sm-10">
                      <button
                          type="button"
                          className="btn btn-success"
                          disabled={this.state.disabled}
                          onClick={ this.handleSubmit }>
                          Submit
                      </button>
                      <button
                          type="button"
                          className="btn btn-danger pull-right"
                          value="Cancel"
                          onClick={ this.handleCancel }>
                          Cancel
                      </button>
                  </div>
              </div>
          </div>
      );
  }

}


export default connect(
  (state) => {
      return {
          Users: state.user.users,
          clientall: state.user.clientall,
          senders: state.user.senders,
          getnamespace: state.user.getnamespace,
          templateall: state.user.templateall
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      // actionEdit: ActionEdit,
      actionDelete: ActionDelete,
      actionGetClient: ActionGetClient,
      actionGetSender: ActionGetSender,
      actionGetNameSpace: ActionGetNameSpace,
      actionGetAllTemplate: ActionGetAllTemplate

  }, dispatch),
)(Form);